import palette from '../../palette';
import MuiInputBase from './MuiInputBase';
import Color from "color";

export default {
  root: {
    borderRadius: "2px",
    borderTopLeftRadius: "2px",
    borderTopRightRadius: "2px",
    backgroundColor: palette.white,
    border: "none",
    "&:hover": {
      backgroundColor: palette.white,
      ["@media (hover: none)"]: {
        backgroundColor: palette.white,
      }
    },
    "&$focused": {
      backgroundColor: palette.white,
    },
    "&$error" : {
      border: `1px solid ${palette.redError}`,
      backgroundColor: Color(palette.redError).alpha(0.5).string(),
    },
  },
  input: MuiInputBase.input
};